import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import axios from 'assets/js/axios'

export default function useFetch(route) {
  const token = useSelector(state => state.Login.token)

  const fetch = useCallback(
    params => {
      const headers = {
        Authorization: `Bearer ${token}`
      }

      return axios
        .get(route, { headers, params })
        .then(response => response.data)
    },
    [route, token]
  )

  return fetch
}
